import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20h16","key":"svg-0"}],["path",{"d":"M4 12h16","key":"svg-1"}],["path",{"d":"M4 4h16","key":"svg-2"}]]

/**
 * IconBaselineDensityMedium
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYmFzZWxpbmUtZGVuc2l0eS1tZWRpdW0iCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTQgMjBoMTYiIC8+CiAgPHBhdGggZD0iTTQgMTJoMTYiIC8+CiAgPHBhdGggZD0iTTQgNGgxNiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/baseline-density-medium
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBaselineDensityMedium = createReactComponent('outline', 'baseline-density-medium', 'BaselineDensityMedium', __iconNode);

export default IconBaselineDensityMedium;